import {Controller} from "@hotwired/stimulus"

type SlideshowImage = {
    src: string
    title: string
    photographer: string
    description: string
    user: string
    imageId: string
}

export default class extends Controller {
    open(event: Event) {
        event.preventDefault()

        const grid = this.element.closest("[data-picture-slideshow-grid]")
        if (!grid) return

        const items = Array.from(grid.querySelectorAll<HTMLElement>("[data-picture-slideshow-item]"))
        const images: SlideshowImage[] = []
        let currentIndex = 0

        items.forEach((item) => {
            const src = item.dataset.pictureSlideshowSrc
            if (!src) return

            const image: SlideshowImage = {
                src,
                title: item.dataset.pictureSlideshowTitle || "",
                photographer: item.dataset.pictureSlideshowPhotographer || "",
                user: item.dataset.pictureSlideshowUser || "",
                description: item.dataset.pictureSlideshowDescription || "",
                imageId: item.dataset.pictureSlideshowImageId || ""
            }
            if (item === this.element) {
                currentIndex = images.length
            }

            images.push(image)
        })

        if (images.length === 0) return

        this.dispatch("open", {
            prefix: "picture-slideshow",
            detail: {images, index: currentIndex}
        })
    }
}
